import { balancerSubgraphClient } from './balancer-farm-subgraph.client';
import { rpcProviderService as _rpcProviderService } from '@/services/rpc-provider/rpc-provider.service';
import FarmPools from './entities/farmPools';
import FarmUserInfos from './entities/farmUserInfos';
import FarmingInfos from './entities/farmingInfos';
import BaseFlakeInfos from './entities/baseFlakeInfos';
import UserLeaveRequests from './entities/userLeaveRequests';
import UserFlakeInfos from './entities/userFlakeInfos';
import FlakeCirculates from './entities/flakeCirculates';

import { networkId } from '@/composables/useNetwork';
import { Network } from 'balancer-labs-sdk-fuji';

export default class BalancerSubgraphService {
  farmPools: FarmPools;
  userInfos: FarmUserInfos;
  farmingInfo: FarmingInfos;
  baseFlakeInfos: BaseFlakeInfos;
  userLeaveRequests: UserLeaveRequests;
  userFlakeInfos: UserFlakeInfos;
  flakeCirculates: FlakeCirculates;

  constructor(
    readonly client = balancerSubgraphClient,
    readonly rpcProviderService = _rpcProviderService
  ) {
    // Init entities
    this.farmPools = new FarmPools(this);
    this.userInfos = new FarmUserInfos(this);
    this.farmingInfo = new FarmingInfos(this);
    this.baseFlakeInfos = new BaseFlakeInfos(this);
    this.userLeaveRequests = new UserLeaveRequests(this);
    this.userFlakeInfos = new UserFlakeInfos(this);
    this.flakeCirculates = new FlakeCirculates(this);
  }

  public get blockTime(): number {
    switch (networkId.value) {
      case Network.MAINNET:
        return 13;
      case Network.POLYGON:
        return 2;
      case Network.ARBITRUM:
        return 3;
      case Network.FUJI:
        return 2;
      case Network.KOVAN:
        // Should be ~4s but this causes subgraph to return with unindexed block error.
        return 1;
      default:
        return 13;
    }
  }
}

export const balancerFarmSubgraphService = new BalancerSubgraphService();
